// API Configuration for Client Application
const getApiUrl = () => {
  // For local development, point to port 8002
  if (process.env.REACT_APP_ENV === 'local') {
    return 'http://localhost:8002';
  }
  // For regular development, point to the Spring Boot server
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8002';
  }
  // In production, the React app is served from the Spring Boot application
  // So we can use relative URLs
  return '';
};

export const API_URL = getApiUrl();

// Authentication API endpoints
export const AUTH_API = {
  LOGIN: `${API_URL}/api/signin`,
  LOGOUT: `${API_URL}/api/signout`,
  USER_INFO: `${API_URL}/api/me`,
  REFRESH_TOKEN: `${API_URL}/api/signin/token`,
  VALIDATE_TOKEN: `${API_URL}/api/valid/token`,
};

// Generic API endpoints
export const GENERIC_API = {
  GET_ALL: `${API_URL}/api/generic/all`,
  GET_ONE: `${API_URL}/api/generic/one`,
  CREATE: `${API_URL}/api/generic/create`,
  UPDATE: `${API_URL}/api/generic/update`,
  DELETE: `${API_URL}/api/generic/delete`,
};

// Sync API endpoints
export const SYNC_API = {
  TRIGGER_SYNC: `${API_URL}/api/sync`,
  SYNC_STATUS: `${API_URL}/api/sync/status`,
};

// Setup API endpoints
export const SETUP_API = {
  CHECK_STATUS: `${API_URL}/api/setup/status`,
  SETUP_ORGANIZATION: `${API_URL}/api/setup/organization`,
};

// Host system control (login screen)
export const SYSTEM_API = {
  SHUTDOWN: `${API_URL}/api/open/system/shutdown`,
  RESTART: `${API_URL}/api/open/system/restart`,
};
